/*
 * @Author: chg
 * @Description: 工具类
 */
// 判断一个字符串中的括号是否完全闭合
const checkParentheses = (str) => {
  const stack = []

  for (let i = 0; i < str.length; i++) {
    const char = str[i]

    if (char === '(') {
      // 如果是左括号，则将其入栈
      stack.push(char)
    } else if (char === ')') {
      // 如果是右括号，则判断栈是否为空
      if (stack.length === 0) {
        // 栈为空，说明存在没有匹配的左括号，括号不闭合
        return false
      } else {
        // 栈不为空，将栈顶的左括号出栈，表示匹配成功
        stack.pop()
      }
    }
  }

  // 遍历完字符串后，如果栈为空，则括号完全闭合，否则括号不闭合
  return stack.length === 0
}

// 获取cookie
function getCookie (name) {
  // 将cookie字符串分割成一个数组
  const cookieArray = document.cookie.split(';')

  // 查找匹配的cookie
  for (let i = 0; i < cookieArray.length; i++) {
    let cookie = cookieArray[i]
    // 去除cookie前的空格
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1)
    }
    // 检查该cookie是否是所需的cookie
    if (cookie.indexOf(name + '=') === 0) {
      return cookie.substring(name.length + 1, cookie.length)
    }
  }

  // 如果没有找到，返回undefined
  return undefined
}
// 判断是否是ios
const isiOS = () => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
}
// 判断是否是安卓
const isAndroid = () => {
  return /Android/i.test(navigator.userAgent)
}

// 判断屏幕宽度是否小于425px (大型移动设备)
const isScreenWidthLessThan425px = () => {
  return window.matchMedia('(max-width: 425px)').matches
}

// 格式化表达式, 通过缩进和换行来格式化表达式
function formatExpression (expression) {
  let indentLevel = 0 // 当前缩进级别
  let formattedExpression = '' // 存储格式化后的表达式
  let currentToken = '' // 当前处理的字符序列

  for (let char of expression) {
    if (char === '(' || char === '（') {
      // 遇到左括号（中英文），添加当前词素和左括号，增加缩进
      if (currentToken.trim()) {
        formattedExpression += '\n' + '  '.repeat(indentLevel) + currentToken.trim()
        currentToken = ''
      }
      formattedExpression += '\n' + '  '.repeat(indentLevel) + char
      indentLevel++
    } else if (char === ')' || char === '）') {
      // 遇到右括号（中英文），添加当前词素和右括号，减少缩进
      if (currentToken.trim()) {
        formattedExpression += '\n' + '  '.repeat(indentLevel) + currentToken.trim()
        currentToken = ''
      }
      indentLevel = Math.max(indentLevel - 1, 0) // 防止缩进级别为负
      formattedExpression += '\n' + '  '.repeat(indentLevel) + char
    } else if (char === ',') {
      // 遇到逗号，如果当前词素非空则添加当前词素，然后添加逗号和换行
      if (currentToken.trim()) {
        formattedExpression += '\n' + '  '.repeat(indentLevel) + currentToken.trim()
        currentToken = ''
      }
      formattedExpression += char + '\n' + '  '.repeat(indentLevel)
    } else {
      // 其他字符，累加到当前词素
      currentToken += char
    }
  }

  // 添加最后的词素
  if (currentToken.trim()) {
    formattedExpression += '\n' + '  '.repeat(indentLevel) + currentToken.trim()
  }

  return formattedExpression.trim() // 返回去除首尾空白的格式化表达式
}

// 移除换行符和行首的空白字符（包括空格和制表符）
function restoreOriginal (expression) {
  // 移除字符串中的换行符
  expression = expression.replace(/\n\s*/g, '')

  // 然后移除字符串两端的空白字符
  expression = expression.trim()

  return expression
}

// 获取主域名
const getMainDomain = (url) => {
  try {
    // 创建一个新的URL对象
    let parsedUrl = new URL(url)

    // 获取主机名（包括子域名）
    let hostname = parsedUrl.hostname

    // 将主机名分割成部分
    let parts = hostname.split('.')

    // 只保留最后两部分（主域名）
    // 如果需要更复杂的逻辑以处理像.co.uk这样的顶级域名，可以在这里添加
    if (parts.length > 2) {
      parts = parts.slice(-3) // 对于三级域名，如vip.stock.finance.sina.com.cn，保留最后三部分
    }

    return parts.join('.')
  } catch (error) {
    console.error('Invalid URL:', error)
    return null
  }
}

// 打开新窗口
const openNewWindow = (url) => {
  if (!url) {
    console.error('No URL provided')
    return
  }

  // 使用 window.open() 方法打开新窗口
  window.open(url, '_blank')
}

// 获取url参数
const getUrlParams = (url) => {
  // 通过 ? 分割获取后面的参数字符串
  const urlStr = url.split('?')[1]
  // 创建空对象存储参数
  const obj = {}
  if (urlStr) {
    // 再通过 & 将每一个参数单独分割出来
    const paramsArr = urlStr.split('&')
    for (let i = 0, len = paramsArr.length; i < len; i++) {
    // 再通过 = 将每一个参数分割为 key:value 的形式
      const arr = paramsArr[i].split('=')
      obj[arr[0]] = arr[1]
    }
  }
  return obj
}

// 去除字符串中的空格（TODO: 保留的内容：中英文双引号、换行符、回车符、zcList内元素函数内的文本）
function removeSpacesOutsideQuotes (factorStr) {
  // 资产列表
  // const zcList = [
  //   'ret', '取回报率', 'close', '收盘价', 'open', '开盘价', 'pick', '取出',
  //   'high', '最高价', 'low', '最低价', 'buildSector', '板块构造', 'asset', '资产'
  // ]

  // 构建正则表达式，匹配双引号内的文本以及特定函数调用
  // const regexPattern = zcList.map(zc => `${zc}\\([^\\)]*\\)|${zc}（[^）]*）`).join('|')
  // const regex = new RegExp(`"[^"]*"|“[^”]*”|'[^']*'|${regexPattern}`, 'g')

  // 用于存储双引号内的内容，以免被修改
  let preservedParts = []

  // 将双引号内的内容替换为占位符，并将原始内容保存到preservedParts中
  const placeholderStr = factorStr.replace(/(["“][^"”]+["”])/g, (match) => {
    preservedParts.push(match)
    return `__QUOTE_PLACEHOLDER__`
  })

  // 去除双引号外部多余空格，包括括号内和引号外的空格（保留换行符和回车符）
  // eslint-disable-next-line no-useless-escape
  let processedStr = placeholderStr.replace(/[ \t]*([\(\)\*\+\-\/><=])[ \t]*/g, '$1')

  // 去除逗号前后的空格（保留换行符和回车符）
  processedStr = processedStr.replace(/[ \t]*,[ \t]*/g, ',')

  // 进一步去除双引号前后的空格（保留换行符和回车符）
  processedStr = processedStr.replace(/[ \t]*__QUOTE_PLACEHOLDER__[ \t]*/g, '__QUOTE_PLACEHOLDER__')

  // 将之前保存的双引号内的内容恢复到结果字符串中
  let result = processedStr.replace(/__QUOTE_PLACEHOLDER__/g, () => preservedParts.shift())

  return result
}

export default {
  checkParentheses,
  getCookie,
  isiOS,
  isAndroid,
  isScreenWidthLessThan425px,
  formatExpression,
  restoreOriginal,
  getMainDomain,
  openNewWindow,
  getUrlParams,
  removeSpacesOutsideQuotes
}



// WEBPACK FOOTER //
// ./src/utils/tools.js